import {
  ICountryStrategy,
  ICountryFieldConfig,
  FIELD_USER_NAME,
  FIELD_ALIAS,
  FIELD_BUSINESS_NAME,
  FIELD_CUIT,
  FIELD_COMMERCIAL_ADDRESS,
} from "../../interfaces/countryStrategy";
import { ERRORS_MESSAGES } from "../../utils/constants";

const argentinaFields: ICountryFieldConfig[] = [
  FIELD_USER_NAME,
  FIELD_ALIAS,
  FIELD_BUSINESS_NAME,
  {
    ...FIELD_CUIT,
    order: 4,
  },
  {
    ...FIELD_COMMERCIAL_ADDRESS,
    order: 5,
  },
];

export const argentinaStrategy: ICountryStrategy = {
  code: "ARG",
  name: "Argentina",
  fields: argentinaFields,

  getValidations: () => [
    {
      id: "userName",
      type: "required",
      message: ERRORS_MESSAGES.contactNameRequired,
    },
    {
      id: "name",
      type: "required",
      message: ERRORS_MESSAGES.nameRequired,
    },
    {
      id: "businessName",
      type: "required",
      message: ERRORS_MESSAGES.businessNameRequired,
    },
    {
      id: "cuit",
      type: "required",
      message: ERRORS_MESSAGES.cuitRequired,
    },
    {
      id: "cuit",
      type: "cuit",
      message: ERRORS_MESSAGES.cuitInvalid,
    },
    {
      id: "commercialAddress",
      type: "required",
      message: ERRORS_MESSAGES.commercialAddressRequired,
    },
  ],

  transformSubmitData: (data) => ({
    ...data,
    cuit: (data.cuit as string).replace(/[^0-9]/g, ""),
  }),
};
